import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { TaskType } from "@/app/services/generated/tasktypeService";
import { taskTypeService } from "@/app/services/generated/tasktypeService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasTaskTypesCache {
  taskTypes: TaskTypesCache;
}
// Singleton cache store
const taskTypesCacheStore = new EntityCacheStore<TaskType>(
  EnumCacheEntityType.taskType,
  async () => taskTypeService.getAllTaskTypes()
);

// Ephemeral reader
export default class TaskTypesCache extends EntityWithGuidKeyCache<TaskType> {
  constructor() {
    super(taskTypesCacheStore, (x) => x.id);
  }
}
